import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Input, InputNumber, Select } from 'antd';
import { READWITH, QueryOrder, QueryDetail, errorCatch } from 'fennec-ui'

import { useState } from 'react';
import InputWithSearchModal from '../../components/InputWithSearchModal';
import UserFilter from '../UserFilter';
import UserSelector from '../UserSelector';

const { Option } = Select;

export default function KategoriiUchastnikovNaMeropriyatiyakh(props) {
    const { auth, form } = props;
    const dispatch = useDispatch();

    const [kategoriyaUchastnikov, setKategoriyaUchastnikov] = useState([]);
    const [tantsevalnayaDistsiplina, setTantsevalnayaDistsiplina] = useState([]);
    useEffect(() => {
        form.resetFields();
        READWITH(auth, "KategoriiUchastnikov", [
            QueryOrder("id", "ASC"),
            QueryDetail("model")
        ], ({data}) => {
            setKategoriyaUchastnikov(data);
        }, errorCatch);

        READWITH(auth, "TantsevalnieDistsiplini", [
            QueryOrder("id", "ASC"),
            QueryDetail("model")
        ], ({data}) => {
            setTantsevalnayaDistsiplina(data);
        }, errorCatch);
    }, []);
    const kategoriyaUchastnikovOptions = kategoriyaUchastnikov?.map((i) => <Option key={i.ID} item={i} value={i.ID} label={i.nazvanie}>{i.nazvanie}</Option>);
    const tantsevalnayaDistsiplinaOptions = tantsevalnayaDistsiplina?.map((i) => <Option key={i.ID} item={i} value={i.ID} label={i.nazvanie}>{i.nazvanie}</Option>);
    return (
        <>
            <Form
                form={props.form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    // emailPolzovatelyaID: object.ID,
                    // kommentarii: object.kommentarii,
                    // email: object.email,
                }}
            >
                {/* <Form.Item
                    preserve={"true"}
                    hidden={true}
                    name={"emailPolzovatelyaID"}
                    label={"Контакт федерации"}
                    rules={[{ required: true, message: 'Укажите контакт федерации!' }]}
                >
                    <Input disabled />
                </Form.Item> */}
                <Form.Item label={"Танцевальная дисциплина"}
                    name="tantsevalnayaDistsiplinaID"
                    rules={[
                        { required: true, message: 'Пожалуйста, введите танцевальную дисциплину!' }
                    ]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        optionLabelProp="label"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {tantsevalnayaDistsiplinaOptions}
                    </Select>
                </Form.Item>
                <Form.Item
                    name={"kategoriyaUchastnikovID"}
                    label={"Категория участников"}
                    rules={[{ required: true, message: 'Укажите категорию участников!' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        optionLabelProp="label"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {kategoriyaUchastnikovOptions}
                    </Select>
                </Form.Item>
                <Form.Item label="Сокращенное наименование"
                    name="shortName"
                    rules={[{ required: false, message: 'Пожалуйста, ввeдите сокращенное наименование!' },
                    { max: 15, message: 'Значение должно быть не более 15 символов!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name={"kurator"}
                    label={"Куратор"}
                    rules={[{ required: false, message: 'Укажите куратора!' }]}
                >
                    <InputWithSearchModal valueAsObject={true} auth={auth} title={"Поиск пользователя"} url={"/api/find/finduserfilter"} object={{ }}
                        searchForm={UserFilter}
                        selectForm={UserSelector} />
                </Form.Item>
            </Form>
        </>
    );
}
